// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// Included Token in ApiUrl to change during deploy for delivery in environment

import { version } from '../../package.json';

export const environment = {
  production: false,
  ApiUrl: 'https://boletimsrv-boletimbackend.azuremicroservices.io',
  HomeUrl: 'https://icy-pond-08920ec10.2.azurestaticapps.net',
 // ApiUrl: 'http://localhost:5999',
//  HomeUrl: 'http://localhost:4200',
  clientId: '2e6a5a62-4e8a-4df5-82ff-a269240db875',
  apiScope: 'api://ccee630f-163e-450c-b3b1-548322c38793/access_as_user',
  version: version,
  environment : 'DEVELOPMENT'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
